export default "__VITE_ASSET__Dr$CKvUd__"